import smViewer from './smViewer.vue';
export default smViewer;
